import { Table } from "components/Table";
import { useSurmountDocuments } from "features/Dashboard/hook";
import { accountDocumentsColumns } from "features/Dashboard/v2/SurmountAccountManage/columns";
import { DocumentsWrapper } from "./Documents.styles";

export const Documents = () => {
  const {
    documents,
    isLoading,
    isFetchingNextPage,
    totalPages,
    totalCount,
    fetchNextPage,
  } = useSurmountDocuments();

  return (
    <DocumentsWrapper>
      <div className="documents-header">
        <h2>Account documents</h2>
        <p>Tax forms, statements, and other documents from your account.</p>
      </div>
      <Table
        isLoading={isLoading && !isFetchingNextPage}
        isSubLoading={isFetchingNextPage}
        columns={accountDocumentsColumns}
        data={documents}
        totalRecords={totalCount}
        notFoundText="No documents available"
        showPagination={false}
        customPagination
        handlePageChange={fetchNextPage}
        totalPages={totalPages}
      />
    </DocumentsWrapper>
  );
};
